import CalendarReducer from './Calendar';
import URLReducer from './URL';
import UpdatedSetsReducer from './UpdatedSets';

import { combineReducers } from "redux"

const allReducers = combineReducers({
    calendar: CalendarReducer,
    url: URLReducer,
    updatedSets: UpdatedSetsReducer
})

export default allReducers;
